// src/components/AdminAccess.jsx
import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import Logout from './Logout';
import { Link } from 'react-router-dom';
import { DEPORTES_LISTA } from '../data/deportes';
import '../styles/adminAccess.css';

export default function AdminAccess() {
    const { currentUser } = useAuth();
    const [showPanel, setShowPanel] = useState(false);

    // Sin sesión no se muestra nada: Lorely entra directo en /login
    if (!currentUser) return null;

    return (
        <div className="admin-access">
            <button 
                className="admin-toggle"
                onClick={() => setShowPanel(!showPanel)}
                title="Panel de administración"
            >
                <span className="admin-text">
                    {currentUser.email.split('@')[0]}
                </span>
            </button>

            {showPanel && (
                <div className="admin-panel">
                    <div className="admin-panel-header">
                        <h4>Administración</h4>
                        <button 
                            className="close-panel"
                            onClick={() => setShowPanel(false)}
                        >
                            ×
                        </button>
                    </div>
                    
                    <div className="admin-panel-links">
                        <Link to="/pagar" onClick={() => setShowPanel(false)}>
                            Cobrar (CLABE y QR)
                        </Link>
                        <Link to="/admin/cotizador" onClick={() => setShowPanel(false)}>
                            Cotizador
                        </Link>
                        {DEPORTES_LISTA.map((d) => (
                            <Link key={d.id} to={`/admin/deporte/${d.id}`} onClick={() => setShowPanel(false)}>
                                Gestionar {d.nombre}
                            </Link>
                        ))}
                        <Link to="/admin/bio" onClick={() => setShowPanel(false)}>
                            Gestionar Sobre mí
                        </Link>
                    </div>
                    
                    <div className="admin-panel-footer">
                        <Logout />
                    </div>
                </div>
            )}
        </div>
    );
}